import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Conversation } from '@vendasta/protos/meeting_analysis/v1';
import { MatExpansionModule } from '@angular/material/expansion';
import { LexiconModule } from '@galaxy/lexicon';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { ScoreBadgeComponent } from '../score-badge/score-badge.component';
import { MatChipsModule } from '@angular/material/chips';
import { ParticipantsComponent } from '../participants/participants.component';
import { AttendeesComponent } from '../attendees/attendees.component';
import { SourcePipe } from '../../meeting-list/meeting-list-item/source/source.pipe';

@Component({
  selector: 'meeting-analysis-meeting-details',
  imports: [
    CommonModule,
    LexiconModule,
    MatExpansionModule,
    GalaxyBadgeModule,
    ScoreBadgeComponent,
    MatChipsModule,
    ParticipantsComponent,
    AttendeesComponent,
    SourcePipe,
  ],
  templateUrl: './meeting-details.component.html',
  styleUrl: './meeting-details.component.scss',
  standalone: true,
})
export class MeetingDetailsComponent {
  conversation = input<Conversation | null>();
  duration = computed(() => {
    const conversation = this.conversation();
    if (!conversation?.duration) return 0;

    return Math.floor(parseFloat(conversation.duration) * 1000);
  });

  internalAttendees = computed(() => {
    const attendees = this.conversation()?.internalAttendees || [];
    return [...new Set(attendees)];
  });
  externalAttendeesContactIds = computed(() => {
    const conversation = this.conversation();
    return (
      (conversation?.externalAttendees || [])
        .map((attendee) => attendee.contactId)
        .filter((contactId) => !!contactId) || []
    );
  });
}
